import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, ref } from "vue";
import { getClasses } from "~/js/composables/classes";
import { sanitizeHtml } from "~/js/utils/sanitize-html";

interface Props {
	color?: string;
	alignment?: string;
	utilities?: string;
	html?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextProse',
  props: {
    color: { default: "text-black" },
    alignment: { default: "text-left" },
    utilities: { default: "" },
    html: {}
  },
  setup(__props: any) {

const props = __props;
const classes = ref({
	font: "font-primary tracking-wide font-normal leading-7 text-lg",
	print: "print:table print:text-black print:text-sm",
	prose: "prose prose-sm max-w-content",
	prose_color: `prose-${props.color}`,
	prose_strong: "prose-strong:font-semibold",
	prose_h2: "prose-h2:text-h2-sm md:prose-h2:text-h2-md lg:prose-h2:text-h2-lg prose-h2:text-orange-500",
	prose_h3: "prose-h3:text-h4-sm md:prose-h3:text-h4-md lg:prose-h3:text-h4-lg prose-h3:text-black",
	prose_h4: "prose-h4:text-h4-sm md:prose-h4:text-h4-md lg:prose-h4:text-h4-lg prose-h4:text-black",
	prose_h5: "prose-h5:text-h5-sm md:prose-h5:text-h5-md lg:prose-h5:text-h5-lg prose-h5:text-black",
	prose_ul: "prose-ul:ml-2 prose-ul:pl-4 prose-ul:mb-10 marker:prose-ul:text-3xl",
	prose_ol: "prose-ol:mb-10 marker:prose-ol:font-bold",
});
const sanitizedHtml = computed(() => sanitizeHtml(props.html));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.utilities, _unref(getClasses)(classes.value)]),
    innerHTML: sanitizedHtml.value
  }, null, 10, _hoisted_1))
}
}

})